import React from "react";
import { motion } from "framer-motion";
import image1 from "../../assets/about1.png";
import image2 from "../../assets/about2.png";
import image3 from "../../assets/about3.jpg";
import image4 from "../../assets/about4.png";
import image5 from "../../assets/about5.png";
import "./about.css";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import BackIcon from "../../components/back/back";

export default function AboutUSDesktop() {
    const events = [
        {
            title: "1998: A Vision Takes Root",
            subtitle: "The Humble Beginnings of Jabal Amel Nurseries",
            description:
                "Hussein Tarhini, the visionary founder of Jabal Amel Nurseries, grew up in a farming family surrounded by prickly pears and olive trees. This early connection to nature inspired a lifelong commitment to revolutionizing agriculture in South Lebanon.",
            image: image1,
        },

    ];
    const navigate = useNavigate()
    return (
        <div className="about-us-section" style={{ marginTop: "3rem" }} id="about">
           
            <div className="carousel-container" style={{paddingTop:"5%"}}>
                <h2 className="about-us-title" style={{ fontSize: '2.5rem' }}>About Us</h2>

                {events.map((event, index) => (
                    <motion.div
                        key={index}
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        transition={{ duration: 0.5 }}
                        className="carousel-slide"
                        style={{ marginBottom: "3rem" }}
                    >
                        <div
                            style={{ display: "flex", flexWrap: "wrap", gap: "1.5rem" }}
                            className={`slide-content ${index % 2 === 0 ? "row-normal" : "row-reverse"}`}
                        >
                            <motion.img
                                src={event.image}
                                alt={event.title}
                                className="slide-image"
                                whileHover={{
                                    scale: 1.05,
                                    boxShadow: "0px 10px 20px rgba(0,0,0,0.2)",
                                }}
                                style={{ width: "30%", minWidth: "300px", objectFit: "cover" }}
                            />
                            <div className="slide-text" style={{ flex: 1 }}>
                                <h1 className="slide-title" style={{ fontSize: "2rem" }}>{event.title}</h1>
                                <h2 className="slide-subtitle">{event.subtitle}</h2>
                                <p className="slide-description">{event.description}</p>
                                <Button onClick={() => navigate("/details")} variant="contained" sx={{ backgroundColor: "#CC5500", color: "white" }}> Read More</Button>
                            </div>
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>
    );
}
